import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';

import { TabsSectionConsumer } from 'elements/Tabs/TabsSection/TabsSection';

import styles from './Tabs.css';

const TabsContainer = ({
  children,
  horizontal,
  icons,
  steptracker
}) => {
  const cx = classnames.bind(styles);
  const classes = cx(
    styles.tabs,
    {
      'horizontal': horizontal,
      'withIcons': icons,
      'withSteptracker': steptracker
    }
  );
  if (children.length > 5) {
    throw Error(`Section have a maximum number os 5 tabs. Current number of tabs: ${children.length}.`);
  } else if (horizontal && steptracker) {
    throw Error('Horizontal Sections cannot contain a steptracker');
  }
  return (
    <TabsSectionConsumer>
      {({ handleKeyDown, tabListRef } ) => {
        return (
          <ul
            ref={tabListRef}
            className={classes}
            role={'tablist'}
            onKeyDown={handleKeyDown}
          >
            {children}
          </ul>
        );
      }}
    </TabsSectionConsumer>
  );
};

TabsContainer.propTypes = {
  children: PropTypes.node.isRequired,
  horizontal:  PropTypes.bool,
  icons: PropTypes.bool,
  steptracker: PropTypes.bool,
};

TabsContainer.displayName = 'TabsContainer';

export default TabsContainer;



// WEBPACK FOOTER //
// ./src/uis/elements/Tabs/TabsSection/Tabs/Tabs.js